<template>
  <div></div>
</template>

<script>
export default {
  name: "FeedsRedirect",

  data() {
    return {
      account_type: this.$route.path.split("/")[1],
    };
  },

  created() {
    delete localStorage.current_class_token;
    if (this.account_type === "parent")
      this.$router.push({ name: "ParentFeeds", params: { id: 0 } });
    else this.$router.push({ name: "StudentFeeds", params: { id: 0 } });
  },
};
</script>

<style>
</style>